function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  className: "path",
  d: "M595.74 148.12C600.51 148.12 604.37 151.99 604.37 156.76C604.37 161.3 604.37 166.26 604.37 170.8C604.37 175.57 600.51 179.43 595.74 179.43C477.47 179.43 131.28 179.43 13.01 179.43C8.24 179.43 4.38 175.57 4.38 170.8C4.38 166.26 4.38 161.3 4.38 156.76C4.38 151.99 8.24 148.12 13.01 148.12C131.28 148.12 477.47 148.12 595.74 148.12Z",
  id: "h1lFZdwPIM"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#h1lFZdwPIM",
  opacity: 1,
  fill: "#ffffff",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#h1lFZdwPIM",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#23231f",
  strokeWidth: 2,
  strokeOpacity: 1
}))));

var SvgConveyor = function SvgConveyor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "3.3750000000000426 147.12499999999994 603.9999999999998 35.31",
    width: 550,
    height: 30,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConveyor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/conveyor.d7627b17.svg";
export { ForwardRef as ReactComponent };